import { JsonObject } from 'json2typescript';
import CartItem from './CartItem';

@JsonObject('CartItemRank')
export default class CartItemRank extends CartItem {
  constructor() {
    super();
    this.rankCode = '';
    this.rankTitle = '';
  }

  public get code(): string {
    return this.rankCode;
  }

  public set code(v: string) {
    this.rankCode = v;
  }

  public get title(): string {
    return this.rankTitle;
  }

  public set title(v: string) {
    this.rankTitle = v;
  }

  // eslint-disable-next-line class-methods-use-this
  public get options(): { typeTitle: string; title: string }[] {
    return [];
  }

  public rankCode: string;

  public rankTitle: string;
}
